import type { StaffComplianceProfile } from '../../types';

/**
 * The person's name for the compliance profile and print headers, shared so
 * the two surfaces cannot drift (the print page is the artifact that goes
 * into an inspection folder).
 *
 * Prefers the server's `staff` identity — present even on an EMPTY profile,
 * which is exactly when an admin is about to file a first vetting and a
 * missing name risks mis-filing. Falls back to the per-record
 * staffNameSnapshot for a backend that predates the `staff` field; returns
 * '' when neither exists so callers choose their own placeholder.
 */
export function staffDisplayName(profile: StaffComplianceProfile | undefined): string {
  const fromServer = [profile?.staff?.firstName, profile?.staff?.lastName]
    .filter(Boolean)
    .join(' ');
  if (fromServer) return fromServer;
  return (
    profile?.vetting.find((v) => v.staffNameSnapshot)?.staffNameSnapshot ||
    profile?.credentials.find((c) => c.staffNameSnapshot)?.staffNameSnapshot ||
    profile?.references.find((r) => r.staffNameSnapshot)?.staffNameSnapshot ||
    ''
  );
}
